// extracted by mini-css-extract-plugin
module.exports = {"group":"form-input_group__2zb9d","form-input":"form-input_form-input__3XXg0","form-input-label":"form-input_form-input-label__1bgqe","shrink":"form-input_shrink__bMhsz"};